// Contas de arrastar: alça da imagem e divisor de colunas.
export const resizeWidth = ({ startPx, dx, corner, align, max }) => {
  const direction = corner.endsWith('left') ? -1 : 1;
  const factor = align === 'center' ? 2 : 1;
  const next = Math.round(startPx + direction * dx * factor);
  return Math.max(20, Math.min(max, next));
};

export const dragWidths = (widths, index, dxPx, contentPx) => {
  const deltaPct = Math.round(((dxPx / contentPx) * 100) / 5) * 5;
  const out = [...widths];
  const pair = out[index] + out[index + 1];
  const left = Math.max(10, Math.min(pair - 10, out[index] + deltaPct));
  out[index] = left;
  out[index + 1] = pair - left;
  return out;
};
